import { Alert, Link, Skeleton, Text } from '@backstage/ui';

import type { HistoryDays } from '@internal/scorecards-common';
import styles from './HistoryChecksTable.module.css';
import { useTeamCheckHistory } from '../../hooks/useTeamCheckHistory';

export interface ExpandedPanelProps {
  checkId: string;
  team: string;
  days: HistoryDays;
}

export const ExpandedPanel = ({ checkId, team, days }: ExpandedPanelProps) => {
  const { loading, error, rows } = useTeamCheckHistory(team, checkId, days);

  if (loading) {
    return (
      <div className={styles.expandedPanel} aria-busy="true">
        <Skeleton width="100%" height={40} />
        <Skeleton width="100%" height={40} />
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.expandedPanel}>
        <Alert
          status="danger"
          icon
          title={`Failed to load projects: ${error.message}`}
        />
      </div>
    );
  }

  const failingRows = rows?.filter(row => row.currentlyFailing);

  if (!failingRows?.length) {
    return (
      <div className={styles.expandedPanel}>
        <Text as="p" variant="body-small" color="secondary">
          No project data available.
        </Text>
      </div>
    );
  }

  return (
    <div className={styles.expandedPanel}>
      {failingRows.map(row => (
        <Link
          key={row.projectPath}
          href={row.entityUrl}
          variant="body-medium"
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            display: 'block',
          }}
        >
          {row.projectName}
        </Link>
      ))}
    </div>
  );
};
